import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { StatusRastreoDTOList } from "./listastatus";

import { TabItem } from "kea-react/src/tabs/tab";
import { RastreoGuia } from "./guia"
import { FolioGuia, FolioGuiaEdit } from "./folio";
export interface Props {
    folios: string[];
    onQuitarFolio: (folio: string) => void;
    onAgregarFolio: (folio: string) => void;
    onQuitarTodo: () => void;
    onRecuperarGuias: () => void;
    verMensajeMaximo: boolean;
    verRecuperarGuias: boolean;
}

export class RastreoGuias extends React.PureComponent<Props> {
    modalManager = kea.createModalManager();

    handleQuitarGuia = async (folio: string) => {
        if (await kea.yesno(`¿Quitar la guia ${folio} del rastreo?`)) {
            await this.props.onQuitarFolio(folio);
        }
    }

    handleOnAgregar = async () => {
        const ret = await this.modalManager.showModal(FolioGuiaEdit, {}, {} as FolioGuia);
        if (ret.result) {
            await this.props.onAgregarFolio(ret.value.folio);

        }
    }

    render() {
        const folios = this.props.folios;
        return (
            <div>
                <kea.Title titulo="Rastreo de guías"
                    onAgregar={this.handleOnAgregar}
                >
                    {
                        (this.props.folios.length > 0) &&
                        <kea.Button onClick={this.props.onQuitarTodo} iconClass={fa("remove")} style="danger">
                            Quitar todo
                        </kea.Button>
                    }
                </kea.Title>
                {
                    this.props.verMensajeMaximo &&
                    <div className="alert alert-warning">
                        Máximo <b>10 guías</b>
                    </div>
                }
                {
                    this.props.verRecuperarGuias &&
                    <div className="alert alert-warning">
                        <label>Recuperar guías</label>
                        <br />
                        Se recordaron las guías rastreadas de la sesión anterior.
                        <br />
                        <kea.Button onClick={this.props.onRecuperarGuias} iconClass={fa("backward")} style="info">
                            Recuperar guias
                        </kea.Button>
                    </div>
                }
                {
                    folios.length == 0 ?
                        <div className="alert alert-info">
                            <label>Agregue guias al rastreo</label>
                            <br />
                            De click en <b>Agregar</b> para incluir una guía en el rastreo
                    </div> :
                        <kea.Tab items={
                            folios.map<TabItem>(x => ({
                                title: x,
                                body:
                                    <div key={x}>
                                        <kea.Link iconClass={fa("eye-slash")} style="danger" onClick={() => this.handleQuitarGuia(x)} >
                                            Dejar de visualizar esta guía en el rastreo
                                             </kea.Link>
                                        <RastreoGuia folio={x} />
                                    </div>
                            }))
                        } />
                }
                {this.modalManager.component}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/rastreo/guias.tsx